// extracted by mini-css-extract-plugin
module.exports = {"PreloaderPageWrap":"Preloader_PreloaderPageWrap__3zCx0","loader":"Preloader_loader__4UTxj","spin":"Preloader_spin__2zYy0"};